module.exports = __webpack_public_path__ + "static/media/random-name-picker.a15c5715.png";